/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeUser } from './ChallengeUser';
import {
    ChallengeUserFromJSON,
    ChallengeUserFromJSONTyped,
    ChallengeUserToJSON,
    ChallengeUserToJSONTyped,
} from './ChallengeUser';

/**
 * Collection tracks which users are participating in which challenges. User must accept a challenge to participate.
 * @export
 * @interface ChallengeMembership
 */
export interface ChallengeMembership {
    /**
     * 
     * @type {string}
     * @memberof ChallengeMembership
     */
    id: string;
    /**
     * The ID of the user participating in the challenge.
     * @type {string}
     * @memberof ChallengeMembership
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeMembership
     */
    challenge: string;
    /**
     * The prizes user has won from the raffle for this challenge.
     * @type {Array<string>}
     * @memberof ChallengeMembership
     */
    prizesWon?: Array<string>;
    /**
     * The timestamp when the user claimed the rewards for this challenge.
     * @type {number}
     * @memberof ChallengeMembership
     */
    rewardClaimDate?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeMembership
     */
    notifiedWinner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeMembership
     */
    dismissedCompleteFeedback?: boolean;
    /**
     * True once the user has been through the post-signup onboarding flow (avatar/nickname capture for branded challenges). Set on Submit OR Skip — never re-set. Gates whether the onboarding modal auto-pops on each login.
     * @type {boolean}
     * @memberof ChallengeMembership
     */
    onboardingComplete?: boolean;
    /**
     * True if this user has qualified via a round win and is excluded from future round winner pools. They remain active and may still earn points.
     * @type {boolean}
     * @memberof ChallengeMembership
     */
    isQualified?: boolean;
    /**
     * The segment index at which the user qualified. Null until qualified.
     * @type {number}
     * @memberof ChallengeMembership
     */
    qualifiedAtSegmentIndex?: number | null;
    /**
     * Map of eligibility/attestation values captured at registration, keyed by Challenge.eligibilityCheckboxes[].key (e.g. {isUSResident true}). Null/missing for memberships created before the registration step ran.
     * @type {{ [key: string]: boolean; }}
     * @memberof ChallengeMembership
     */
    eligibility?: { [key: string]: boolean; };
    /**
     * Membership status. "eligible" = full participant, can win prizes; "prize-restricted" = participates + earns + on Global LB, cannot win; "spectator" = view-only (no earning, no spin); "disabled" = removed from this surface. Every downstream consumer (draw, spin, leaderboard scope) reads this single field.
     * @type {string}
     * @memberof ChallengeMembership
     */
    status: ChallengeMembershipStatusEnum;
    /**
     * Unix timestamp (ms) when the user completed the challenge registration step (accepted terms + any required eligibility checkboxes). Null until they register. Earning endpoints gate on this being non-null.
     * @type {number}
     * @memberof ChallengeMembership
     */
    acceptedTermsAt?: number | null;
    /**
     * Snapshot of the terms version the user accepted at registration. Used for audit trail when terms change.
     * @type {string}
     * @memberof ChallengeMembership
     */
    termsVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeMembership
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeMembership
     */
    adminTriggeredBy?: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeMembership
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeMembership
     */
    updatedAt?: number;
    /**
     * 
     * @type {ChallengeUser}
     * @memberof ChallengeMembership
     */
    user?: ChallengeUser;
}


/**
 * @export
 */
export const ChallengeMembershipStatusEnum = {
    eligible: 'eligible',
    PrizeRestricted: 'prize-restricted',
    spectator: 'spectator',
    disabled: 'disabled'
} as const;
export type ChallengeMembershipStatusEnum = typeof ChallengeMembershipStatusEnum[keyof typeof ChallengeMembershipStatusEnum];


/**
 * Check if a given object implements the ChallengeMembership interface.
 */
export function instanceOfChallengeMembership(value: object): value is ChallengeMembership {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('challenge' in value) || value['challenge'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ChallengeMembershipFromJSON(json: any): ChallengeMembership {
    return ChallengeMembershipFromJSONTyped(json, false);
}

export function ChallengeMembershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeMembership {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'challenge': json['challenge'],
        'prizesWon': json['prizesWon'] == null ? undefined : json['prizesWon'],
        'rewardClaimDate': json['rewardClaimDate'] == null ? undefined : json['rewardClaimDate'],
        'notifiedWinner': json['notifiedWinner'] == null ? undefined : json['notifiedWinner'],
        'dismissedCompleteFeedback': json['dismissedCompleteFeedback'] == null ? undefined : json['dismissedCompleteFeedback'],
        'onboardingComplete': json['onboardingComplete'] == null ? undefined : json['onboardingComplete'],
        'isQualified': json['isQualified'] == null ? undefined : json['isQualified'],
        'qualifiedAtSegmentIndex': json['qualifiedAtSegmentIndex'] == null ? undefined : json['qualifiedAtSegmentIndex'],
        'eligibility': json['eligibility'] == null ? undefined : json['eligibility'],
        'status': json['status'],
        'acceptedTermsAt': json['acceptedTermsAt'] == null ? undefined : json['acceptedTermsAt'],
        'termsVersion': json['termsVersion'] == null ? undefined : json['termsVersion'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'adminTriggeredBy': json['adminTriggeredBy'] == null ? undefined : json['adminTriggeredBy'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'user': json['user'] == null ? undefined : ChallengeUserFromJSON(json['user']),
    };
}

export function ChallengeMembershipToJSON(json: any): ChallengeMembership {
    return ChallengeMembershipToJSONTyped(json, false);
}

export function ChallengeMembershipToJSONTyped(value?: ChallengeMembership | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'challenge': value['challenge'],
        'prizesWon': value['prizesWon'],
        'rewardClaimDate': value['rewardClaimDate'],
        'notifiedWinner': value['notifiedWinner'],
        'dismissedCompleteFeedback': value['dismissedCompleteFeedback'],
        'onboardingComplete': value['onboardingComplete'],
        'isQualified': value['isQualified'],
        'qualifiedAtSegmentIndex': value['qualifiedAtSegmentIndex'],
        'eligibility': value['eligibility'],
        'status': value['status'],
        'acceptedTermsAt': value['acceptedTermsAt'],
        'termsVersion': value['termsVersion'],
        'notes': value['notes'],
        'adminTriggeredBy': value['adminTriggeredBy'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'user': ChallengeUserToJSON(value['user']),
    };
}

